import makeList from './makeList.js'

let viewFloor = '観測棟'

let params = [
  {
    name: 'syowa',
    locations: [
      { description: '観測棟入口',
        file: './data/I3f.JPG',
        rotation: 11.517739897668198,
        link: [
          {
            file: './data/I3c.JPG',
            position: [ 3361.7533931549283, 2087.58110064065, -3048.7159735254318 ],
          },
          {
            file: './data/11_R0010666.JPG',
            position: [ -3844.086154982715, 1986.6805064959804, 2488.6507706436496 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 372.63626251390434, 285.87319243604003 ],
          syowaZoom: [ 441.02564102564105, 423.2564102564103 ],
        },
      },
      { description: '観測棟(1)',
        file: './data/I3a.JPG',
        rotation: 8.728476132554086,
        link: [
          {
            file: './data/I3b.JPG',
            position: [ 3478.3606751294224, -529.0480114589963, 3538.3898935278494 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 372.63626251390434, 285.87319243604003 ],
          syowaZoom: [ 484.61538461538464, 277.1025641025641 ],
        },
      },
      { description: '観測棟(2)',
        file: './data/I3b.JPG',
        rotation: 194.24366397480753,
        link: [
          {
            file: './data/I3a.JPG',
            position: [ -1233.5487644560428, 117.05207253962399, -4834.003785770714 ],
          },
          {
            file: './data/I3c.JPG',
            position: [ 4613.252967866161, 145.81118970292113, 1899.1203409171194 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 372.63626251390434, 285.87319243604003 ],
          syowaZoom: [ 389.7435897435898, 334.36752136752136 ],
        },
      },
      { description: '観測棟(3)',
        file: './data/I3c.JPG',
        rotation: -174.16971055207364,
        link: [
          {
            file: './data/I3b.JPG',
            position: [ -3807.381165769071, -3.0440017394300206e-13, -3232.466040625705 ],
          },
          {
            file: './data/I3f.JPG',
            position: [ -4666.698200607848, 100.10806798362884, -1764.8947958592044 ],
          },
          {
            file: './data/I3d.JPG',
            position: [ 3956.764775787181, -250.59428924597702, 3032.3686962894444 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 372.63626251390434, 285.87319243604003 ],
          syowaZoom: [ 294.8717948717949, 391.6324786324787 ],
        },
      },
      { description: '観測棟(4)',
        file: './data/I3d.JPG',
        rotation: 139.37102586153762,
        link: [
          {
            file: './data/I3c.JPG',
            position: [ -4303.153037244567, 250.1130170903871, -2523.517924482606 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 372.63626251390434, 285.87319243604003 ],
          syowaZoom: [ 200.00000000000003, 448.8974358974359 ],
        },
      },
    ],
  },
]

export default makeList(params,viewFloor)
